import React from 'react';
import { useNavigate } from 'react-router-dom';

type RouteMapItem = {
  route: string;
  component: string;
  file: string;
};

const ROUTE_MAP: RouteMapItem[] = [
  { route: '/customers-m', component: 'CustomersReportMobile', file: 'src/components/reference/customerm.tsx' },
  { route: '/customers-d', component: 'CustomersReportdesktop', file: 'src/components/reference/customerd.tsx' },
  { route: '/checkin-m', component: 'CheckinReportMobile', file: 'src/components/reference/checkinm.tsx' },
  { route: '/checkin-d', component: 'CheckinReportDesktop', file: 'src/components/reference/CheckinReportDesktop.tsx' },
  { route: '/eod-d', component: 'PaymentsAccountingDesktop', file: 'src/components/reference/eodd.tsx' },
  { route: '/eod-m', component: 'PaymentsAccountingMobile', file: 'src/components/reference/eodm.tsx' },
  { route: '/labour-d', component: 'LabourReportDesktop', file: 'src/components/reference/labourd.tsx' },
  { route: '/labour-m', component: 'LabourReportMobile', file: 'src/components/reference/labourm.tsx' },
  { route: '/reservationdm', component: 'ReservationDashboard', file: 'src/components/reference/reservationdm.tsx' },
  { route: '/event-d', component: 'EventsPreOrderDesktop', file: 'src/components/reference/eventd.tsx' },
  { route: '/event-m', component: 'EventsPreOrderMobile', file: 'src/components/reference/eventm.tsx' },
  { route: '/sales-m', component: 'SalesReference', file: 'src/components/reference/sales.tsx' },
  { route: '/sales-d', component: 'SalesReportDesktop', file: 'src/components/reference/sales-desktop.tsx' },
  { route: '/prod-m', component: 'MobileSnapSaleProd', file: 'src/components/reference/mobile-snap-sale-prod.tsx' },
  { route: '/multi-outlet-landing', component: 'MultiOutletLanding', file: 'src/components/reference/multi-outletlanding.tsx' },
  { route: '/snapshot-m', component: 'MobileV61', file: 'src/components/reference/mobile-v6-1.tsx' },
  { route: '/snapshot-d', component: 'DesktopV61', file: 'src/components/reference/desktop-v6-1.tsx' },
  { route: '/product-d', component: 'ProductV61', file: 'src/components/reference/proudct-v6-1.tsx' },
];

const cardStyle: React.CSSProperties = {
  background: 'var(--surface)',
  border: '1px solid var(--card-border)',
  borderRadius: 14,
  boxShadow: 'var(--card-shadow)',
  padding: 16,
};

const rowButtonStyle: React.CSSProperties = {
  width: '100%',
  textAlign: 'left',
  border: '1px solid var(--card-border)',
  borderRadius: 10,
  background: 'var(--surface)',
  padding: '12px 14px',
  cursor: 'pointer',
  marginBottom: 10,
};

const pillStyle: React.CSSProperties = {
  borderRadius: 6,
  border: '1px solid var(--card-border)',
  padding: '3px 8px',
  fontSize: 11,
  color: 'var(--t2)',
  fontFamily: "'DM Mono', 'SF Mono', 'Consolas', monospace",
  background: 'var(--hover)',
};

export default function ReferenceRouteMapPage() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', padding: 20 }}>
      <div style={{ maxWidth: 980, margin: '0 auto' }}>
        <div style={{ marginBottom: 14 }}>
          <div style={{ color: 'var(--t1)', fontSize: 22, fontWeight: 700 }}>UI Reference Routing Map</div>
          <div style={{ color: 'var(--t2)', fontSize: 13, marginTop: 6 }}>
            Click any route below to navigate directly to that reference screen.
          </div>
        </div>

        <div style={cardStyle}>
          <div style={{ color: 'var(--t1)', fontSize: 16, fontWeight: 700, marginBottom: 10 }}>Reference Routes</div>
          {ROUTE_MAP.map((item) => (
            <button
              key={item.route}
              type="button"
              style={rowButtonStyle}
              onClick={() => navigate(item.route)}
              title={`Open ${item.route}`}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, marginBottom: 8 }}>
                <span style={{ color: 'var(--accent)', fontWeight: 700, fontSize: 14 }}>{item.route}</span>
                <span style={pillStyle}>Open</span>
              </div>
              <div style={{ color: 'var(--t1)', fontSize: 12, fontWeight: 600 }}>{item.component}</div>
              <div style={{ color: 'var(--t2)', fontSize: 11, marginTop: 4 }}>{item.file}</div>
            </button>
          ))}
        </div>

      </div>
    </div>
  );
}
